import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

/**
 * Application Entry Point
 *
 * Renders <App />, which sets up the providers, the <BrowserRouter>, and the
 * router. All routes are defined in src/router.tsx (explicit <Routes>).
 */

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
